module.exports = __webpack_public_path__ + "img/4_64.5d15cd00.png";